/**
 * @ngdoc directive
 * @module components.carousel
 * @name components.carousel:carouselSync
 * @scope
 * @restrict E
 * @description
 * Container that syncs carousels and carousel navs.
 * @example
        <example module="dataExample">
            <file name="index.html">
                <div ng-controller="exampleController">
                    <carousel-sync>
                        <carousel slides="slides">
                            <slide>
                                <h3 style="background-color: red; padding: 1em; width: 100%;">{{slide.name}}</h3>
                            </slide>
                        </carousel>
                        <carousel slides="slides">
                            <slide>
                                <div ng-bind-html="slide.summary"></div>
                            </slide>
                        </carousel>
                    </carousel-sync>
                </div>
            </file>
            <file name="script.js">
                (function() {
                    angular.module('dataExample', ['components.carousel'])
                        .controller('exampleController', exampleController);

                    exampleController.$inject = ['$scope'];
                    function exampleController($scope) {
                        $scope.slides = [];
                        for (var i=0; i<5; i++) {
                            $scope.slides.push({
                                name: 'Slide ' + i,
                                summary: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam eu pharetra ex. Curabitur eu nunc id dolor laoreet consectetur nec ornare elit. Vivamus elementum turpis ac mi vehicula fermentum. Morbi eget neque justo. Cras id elit condimentum felis vehicula suscipit. Maecenas sagittis pulvinar ante, eu cursus justo placerat ac. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam lacus leo, tristique eu nunc a, placerat placerat tortor. Fusce eget consectetur ante. Suspendisse lobortis dui libero. In ac libero vel eros ultricies auctor nec in felis. Vestibulum sed odio orci.</p><p>Curabitur pellentesque lobortis dui, et luctus ex convallis id. Cras scelerisque augue at imperdiet placerat. In diam velit, congue at diam ut, iaculis feugiat turpis. Donec id elit id elit vestibulum semper. Curabitur quis neque quis ipsum ultricies tincidunt vitae varius lectus. Proin at erat vestibulum, hendrerit urna ac, cursus mi. Cras pulvinar at felis vitae gravida. Nunc egestas rhoncus felis, vel vestibulum nisl condimentum quis. Vestibulum quis iaculis elit.</p>'
                            });
                        }
                    }
                })();
            </file>
        </example>
 */
(function () {
	angular.module('components.carousel')
		.component('carouselSync', {
			controller: carouselSyncController
		});

	function carouselSyncController() {
		var ctrl = this;
		ctrl.$onInit = function() {
			ctrl.$carousels = [];
        };
		ctrl.registerCarousel = function(carousel) {
		    ctrl.$carousels.push(carousel);
            return ctrl.$carousels.length - 1;
		};

		ctrl.updateCarousels = function (index, carouselIndex) {
		    //console.log(index, carouselIndex);
            for (var i = 0; i < ctrl.$carousels.length; i++) {
                if (i !== carouselIndex) {
                    ctrl.$carousels[i].goToSlide(index, true, true);
                }
            }
        };
	}
})();